import { render, staticRenderFns } from "./certidao_detalhe.vue?vue&type=template&id=675c0738&scoped=true"
import script from "./certidao_detalhe.vue?vue&type=script&lang=js"
export * from "./certidao_detalhe.vue?vue&type=script&lang=js"
import style0 from "./certidao_detalhe.vue?vue&type=style&index=0&id=675c0738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675c0738",
  null
  
)

export default component.exports